import { PartialNullable } from './types';
import UUID from '../model/UUID';
import _ from 'lodash';

export const transfer = <T>(
  source: T[],
  destination: T[],
  predicate: (element: T) => boolean
) => {
  const [_source, _destination] = [[...source], [...destination]];
  const position = _.findIndex(_source, predicate);
  if (position !== -1) {
    _destination.push(_source[position]);
    _source.splice(position, 1);
  }
  return [_source, _destination];
};

export const move = <T>(array: T[], fromIndex: number, toIndex: number) => {
  const _array = [...array];
  _array.splice(toIndex, 0, _array.splice(fromIndex, 1)[0]);
  return _array;
};

export const add = <T>(array: T[], value: T): T[] => {
  const _array = [...array];
  _array.push(value);
  return _array;
};

export const addUnique = <T>(array: T[], value: T): T[] => {
  return array.includes(value) ? array : add(array, value);
};

export const remove = <T>(array: T[], index: number) => {
  const _array = [...array];
  _array.splice(index, 1);
  return _array;
};

export const removeById = <T extends { id: UUID }>(array: T[], id: UUID) => {
  const _array = [...array];
  _.remove(_array, v => v.id === id);
  return _array;
};

export const removeByValue = <T>(array: T[], value: T) => {
  const _array = [...array];
  _.remove(_array, element => element === value);
  return _array;
};

export const replaceById = <T extends { id: UUID }>(array: T[], value: T) => {
  const _array = [...array];
  var index = _.findIndex(array, i => i.id === value.id);
  _array.splice(index, 1, value);
  return _array;
};

export const findNext = <T>(
  array: T[],
  predicate: (element: T) => boolean
): T | null => {
  const _array = [...array];
  const position = _.findIndex(_array, predicate);
  if (position !== -1 && _array.length > position + 1) {
    return _array[position + 1];
  }
  return null;
};

export const findObj = <T extends object>(
  array: T[],
  predicate: (object: T) => boolean
): T | PartialNullable<T> => {
  return _.find(array, predicate) || {};
};

export const fixOrder = <T extends { order: number }>(array: T[]) =>
  _.map(array, (v, index) => ({
    ...v,
    ...{ order: index },
  }));
